<template>
  <div>
    <b-form-input v-if="readonly" :value="name" :readonly="true" />
    <multiselect
      v-else
      v-model="selectedValue"
      label="account_name"
      @input="input($event)"
      :options="options"
      :allow-empty="allowEmpty"
      :show-labels="showLabels"
      track-by="account_name"
    >
      <template #singleLabel="{ option }">
        {{ option.account_name }}
        <small v-if="option.distance_from_job !== null">
          - {{ (option.distance_from_job / 1000).toFixed(2) }} km
        </small>
        <small v-else class="text-warning">(missing-coordinates)</small>
      </template>
      <template #option="{ option }">
        <div>
          {{ option.account_name }}
          <small v-if="option.distance_from_job !== null">
            - {{ (option.distance_from_job / 1000).toFixed(2) }} km
          </small>
          <small v-else class="text-warning">(missing-coordinates)</small>
          <b-badge v-if="option.in_rejected_jobs" variant="light" class="ml-1">
            {{ $t('inputs.partner.rejected-job') }}
            <template
              v-if="
                option.rejected_jobs[0] &&
                option.rejected_jobs[0].reason_category
              "
            >
              - {{ option.rejected_jobs[0].reason_category }}
            </template>
          </b-badge>
          <b-badge
            v-if="option.in_rejected_brands"
            variant="light"
            class="ml-1"
          >
            {{ $t('inputs.partner.rejected-brand') }}
          </b-badge>
          <b-badge
            v-if="option.in_rejected_opportunities"
            variant="light"
            class="ml-1"
          >
            {{ $t('inputs.partner.rejected-opportunity') }}
          </b-badge>
          <b-badge
            v-if="option.in_rejected_services"
            variant="light"
            class="ml-1"
          >
            {{ $t('inputs.partner.rejected-service') }}
          </b-badge>
        </div>
      </template>
    </multiselect>
    <div
      v-if="!readonly"
      class="d-flex justify-content-between align-items-baseline pt-2"
    >
      <b-button
        size="sm"
        v-if="selectedValue"
        :href="`/data-ui/Partner/${selectedValue.partner_id}`"
        target="_blank"
        rel="noreferrer"
      >
        {{ $t('inputs.partner.sf-link', { partner_name: selectedValue.name }) }}
        <i class="material-icons">open_in_new</i>
      </b-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import BaseInput from './mixins/BaseInput';
import { PARTNER_ASSIGNED } from './_types';

export default {
  mixins: [BaseInput],
  components: {
    Multiselect,
  },
  props: {
    name: String,
    job_sfid: String,
    job_status: {
      type: String,
      default: null,
    },
    job_subStatus: {
      type: Array,
      default: null,
    },
    inputName: {
      type: String,
      default: PARTNER_ASSIGNED,
    },
  },
  data() {
    return {
      partners: [],
    };
  },
  watch: {
    readonly(value) {
      if (!value && this.partners.length == 0) {
        this.initPartners();
      }
    },
  },
  computed: {
    ...mapGetters(['locale']),
    selectedValue: {
      get: function () {
        return this.partners.find((item) => item.partner_id == this.value);
      },
      set: function (newValue) {
        this.commitValue(newValue);
      },
    },
    allowEmpty() {
      return true;
    },
    showLabels() {
      return false;
    },
    options() {
      return this.partners;
    },
  },
  created() {
    if (!this.readonly) {
      this.initPartners();
    }
  },
  methods: {
    input(event) {
      if (event) {
        return this.commitValue(event.partner_id);
      }
      return this.value;
    },
    initPartners() {
      const shouldIncludeAllPartners = this.isPartnerOnBoarding();
      axios
        .get(
          `/api/admin/partners/qualified-for-job/${this.job_sfid}?with_rejections=true&include_all=${shouldIncludeAllPartners}`,
        )
        .then((response) => {
          this.partners = response.data.map((e) => ({
            ...e,
            $isDisabled:
              e.rejected_jobs.length > 0 ||
              e.in_rejected_brands ||
              e.in_rejected_opportunities ||
              e.in_rejected_services,
          }));
        });
    },
    isPartnerOnBoarding() {
      return (
        this.job_status === 'on hold' &&
        this.job_subStatus.includes('on hold.partner-onboarding.pending')
      );
    },
  },
};
</script>
